import { __decorate } from "tslib";
import { singleton } from "tsyringe";
import "../elements/components/title.element.js";
let TitleService = class TitleService {
    constructor() {
        if (document.readyState !== "loading") {
            this.createTitleElement();
        }
        else {
            window.addEventListener("DOMContentLoaded", (event) => {
                this.createTitleElement();
            });
        }
    }
    createTitleElement() {
        if (!this._title) {
            this._title = document.createElement("se-title");
            this._title.hidden = true;
            document.body.appendChild(this._title);
        }
    }
    hideTitle() {
        if (this._title) {
            this._title.style.left = "-1000px";
            this._title.style.top = "-1000px";
            this._title.hide();
        }
    }
    async showTitleAsync(target, title, description, maxWidth, noDelay, position) {
        if (position === "right") {
            const rect = target.getBoundingClientRect();
            this._title.showTitle(title, description, maxWidth);
            this._title.style.maxWidth = window.innerWidth - 20 + "px";
            this._title.style.left = "-1000px";
            this._title.style.top = "-1000px";
            this._title.hidden = false;
            this._title.requestUpdate();
            await this._title.updateComplete;
            const titleRect = this._title.getBoundingClientRect();
            let left = rect.right;
            if (left + titleRect.width > window.innerWidth - 10) {
                left = window.innerWidth - titleRect.width - 10;
            }
            let top = rect.top;
            if (top + titleRect.height > window.innerHeight - 10) {
                top = window.innerHeight - titleRect.height - 10;
            }
            this._title.style.left = left + "px";
            this._title.style.top = top + "px";
        }
        else if (this._title) {
            const rect = target.getBoundingClientRect();
            this._title.showTitle(title, description, maxWidth);
            this._title.style.maxWidth = window.innerWidth - 20 + "px";
            this._title.style.left = "-1000px";
            this._title.style.top = "-1000px";
            this._title.hidden = false;
            this._title.requestUpdate();
            await this._title.updateComplete;
            const titleRect = this._title.getBoundingClientRect();
            let left;
            if (titleRect.width > rect.width) {
                left = rect.left - (titleRect.width - rect.width) / 2;
            }
            else {
                left = rect.left + (rect.width - titleRect.width) / 2;
            }
            if (left < 10) {
                left = 10;
            }
            else if (left + titleRect.width > window.innerWidth - 10) {
                left = window.innerWidth - titleRect.width - 10;
            }
            let top = rect.bottom + 5;
            if (top + titleRect.height > window.innerHeight - 10) {
                top = rect.top - titleRect.height - 5;
            }
            this._title.style.left = left + "px";
            this._title.style.top = top + "px";
        }
    }
};
TitleService = __decorate([
    singleton()
], TitleService);
export { TitleService };
//# sourceMappingURL=title.service.js.map